// ** React Imports
import { useState, SyntheticEvent, Fragment, useEffect, useRef } from 'react'

// ** Next Import
import { useRouter } from 'next/router'

// ** MUI Imports
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import Badge from '@mui/material/Badge'
import Avatar from '@mui/material/Avatar'
import Divider from '@mui/material/Divider'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import LogoutIcon from 'mdi-material-ui/Logout';

// ** Icons Imports
import CogOutline from 'mdi-material-ui/CogOutline'
import CurrencyUsd from 'mdi-material-ui/CurrencyUsd'
import EmailOutline from 'mdi-material-ui/EmailOutline'
import LogoutVariant from 'mdi-material-ui/LogoutVariant'
import AccountOutline from 'mdi-material-ui/AccountOutline'
import MessageOutline from 'mdi-material-ui/MessageOutline'
import HelpCircleOutline from 'mdi-material-ui/HelpCircleOutline'
// ** Context
import { useAuth } from 'src/hooks/useAuth'

// ** Type Imports
import { Settings } from 'src/@core/context/settingsContext'
import authService from "../../../../components/api-authorization/AuthorizeService"
import { useNavigate } from "react-router-dom";
import { ApplicationPaths } from '../../../../components/api-authorization/ApiAuthorizationConstants'
import AppUser from '../../../../models/AppUser'
import CustomAvatar from 'src/@core/components/mui/avatar'
import { RootState, AppDispatch } from 'src/store'
import { useDispatch, useSelector } from 'react-redux'
import { setActive, setActiveOrg } from 'src/store/apps/lookup'
import { Icon } from '@iconify/react';
import { useTheme } from '@mui/material/styles'
import Tooltip from '@mui/material/Tooltip'

interface Props {
    settings: Settings,
    user: AppUser,
    userAuthenticated: boolean,
    compactView: boolean
}

// ** Styled Components
const BadgeContentSpan = styled('span')(({ theme }) => ({
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.success.main,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`
}))

const UserDropdown = (props: Props) => {
    // ** Props
    const { settings, user, userAuthenticated, compactView } = props

    // ** States
    const [anchorEl, setAnchorEl] = useState<Element | null>(null)
    const [anchorElPrimary, setAnchorElPrimary] = useState<Element | null>(null)

    const store = useSelector((state: RootState) => ({ lookup: state.lookup }))
    const dispatch = useDispatch<AppDispatch>()

    // ** Hooks
    const router = useRouter()
    const { logout } = useAuth()

    const theme = useTheme()

    // ** Vars
    const { direction } = settings

    const handleDropdownOpen = (event: SyntheticEvent) => {
        setAnchorEl(event.currentTarget)
    }

    const handlePrimaryDropdownOpen = (event: SyntheticEvent) => {
        setAnchorElPrimary(event.currentTarget)
    }

    const handleDropdownClose = (url?: string) => {
        if (url) {
            router.push(url)
        }
        setAnchorEl(null)
        setAnchorElPrimary(null)
    }

    const setActiveOrganization = (organization: any) => {
        dispatch(setActiveOrg(organization.id));
        dispatch(setActive({ orgId: organization.id }));
    }

    const styles = {
        py: 2,
        px: 4,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        color: 'text.primary',
        textDecoration: 'none',
        '& svg': {
            fontSize: '1.375rem',
            color: 'text.secondary'
        }
    }

    const handleLogout = () => {
        navigate(ApplicationPaths.LogOut, { replace: true, state: { local: true } });
        //logout()
        //handleDropdownClose()
    }

    let navigate = useNavigate();
    //let _subscription = useRef(0); 
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userName, setUserName] = useState("");

    useEffect(() => {
        setIsAuthenticated(userAuthenticated);
        setUserName(user.name);
    }, [user])

    //useEffect(() => {
    //  _subscription.current = authService.subscribe(() => populateState());
    //    populateState();
    //    console.log("");
    //  return (()=>{
    //    authService.unsubscribe(_subscription.current); 
    //  })
    //}, []);

    //const populateState = async ()=> {
    //  const [isUserAuthenticated, user]  = await Promise.all([authService.isAuthenticated(), authService.getUser()])

    //}


    return (
        <>
            {compactView == false && <Fragment>
                <Badge
                    overlap='circular'
                    onClick={handleDropdownOpen}
                    sx={{ ml: 2, cursor: 'pointer' }}
                    badgeContent={<BadgeContentSpan />}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                >
                    <Avatar
                        alt='John Doe'
                        onClick={handleDropdownOpen}
                        sx={{ width: 40, height: 40 }}
                        src='/images/avatars/1.png'
                    />
                </Badge>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => handleDropdownClose()}
                    sx={{ '& .MuiMenu-paper': { width: 230, marginTop: 4 } }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: direction === 'ltr' ? 'right' : 'left'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: direction === 'ltr' ? 'right' : 'left'
                    }}
                >
                    <Box sx={{ pt: 2, pb: 3, px: 4 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Badge
                                overlap='circular'
                                badgeContent={<BadgeContentSpan />}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right'
                                }}
                            >
                                <Avatar
                                    alt="username"
                                    src='/images/avatars/1.png'
                                    sx={{ width: '2.5rem', height: '2.5rem' }}
                                />
                            </Badge>
                            <Box
                                sx={{
                                    display: 'flex',
                                    marginLeft: 3,
                                    alignItems: 'flex-start',
                                    flexDirection: 'column'
                                }}
                            >
                                <Typography sx={{ fontWeight: 600 }}>{userName}</Typography>
                                <Typography
                                    variant='body2'
                                    sx={{ fontSize: '0.8rem', color: 'text.disabled' }}
                                >
                                    {userName}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Divider sx={{ mt: 0, mb: 1 }} />
                    <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                        <Box sx={styles}>
                            <AccountOutline sx={{ marginRight: 2 }} />
                            Profile
                        </Box>
                    </MenuItem>
                    <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                        <Box sx={styles}>
                            <EmailOutline sx={{ marginRight: 2 }} />
                            Inbox
                        </Box>
                    </MenuItem>
                    <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                        <Box sx={styles}>
                            <MessageOutline sx={{ marginRight: 2 }} />
                            Chat
                        </Box>
                    </MenuItem>
                    <Divider />
                    <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                        <Box sx={styles}>
                            <CogOutline sx={{ marginRight: 2 }} />
                            Settings
                        </Box>
                    </MenuItem>
                    <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                        <Box sx={styles}>
                            <CurrencyUsd sx={{ marginRight: 2 }} />
                            Pricing
                        </Box>
                    </MenuItem>
                    <MenuItem sx={{ p: 0 }} onClick={() => handleDropdownClose()}>
                        <Box sx={styles}>
                            <HelpCircleOutline sx={{ marginRight: 2 }} />
                            FAQ
                        </Box>
                    </MenuItem>
                    <Divider />
                    {isAuthenticated && <MenuItem sx={{ py: 2 }} onClick={handleLogout}>
                        <LogoutVariant
                            sx={{
                                marginRight: 2,
                                fontSize: '1.375rem',
                                color: 'text.secondary'
                            }}
                        />
                        Logout
                    </MenuItem>
                    }
                </Menu>
            </Fragment>
            }
            {compactView && isAuthenticated &&
                <>
                    <CustomAvatar onClick={handlePrimaryDropdownOpen} sx={{ cursor: "pointer" }}>
                        {(user.FirstName && user.LastName) ? user.FirstName.charAt(0) + user.LastName.charAt(0) : user.name.charAt(0)}
                    </CustomAvatar>
                    <IconButton color='inherit' aria-haspopup='true' onClick={handleDropdownOpen}> {/*onClick={handleModeToggle}*/}
                        <LogoutIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => handleDropdownClose()}
                        sx={{ '& .MuiMenu-paper': { width: 230, marginTop: 4 } }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: direction === 'ltr' ? 'right' : 'left'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: direction === 'ltr' ? 'right' : 'left'
                        }}
                    >
                        <MenuItem sx={{ py: 2, alignItems: 'center', justifyContent: 'center', fontWeight: 600 }} onClick={handleLogout}>
                            Logout
                        </MenuItem>
                    </Menu>
                    <Menu
                        anchorEl={anchorElPrimary}
                        open={Boolean(anchorElPrimary)}
                        onClose={() => handleDropdownClose()}
                        sx={{ '& .MuiMenu-paper': { width: 230, marginTop: 4 } }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: direction === 'ltr' ? 'right' : 'left'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: direction === 'ltr' ? 'right' : 'left'
                        }}
                    >
                        <Divider sx={{ mt: 0, mb: 1 }} />
                        {store.lookup.data &&
                            store.lookup.data.userOrgChannels.organizations.map((o) => (
                                <Tooltip
                                    title={
                                        <div>
                                            {
                                                o.channels.map((c: any) => (
                                                    <>
                                                        <Typography variant='caption' sx={{ color: 'common.black', fontWeight: 600 }}>
                                                            {c.name}
                                                        </Typography>
                                                        <br />
                                                    </>
                                                ))
                                            }
                                        </div>
                                    }
                                    placement="left-start"
                                >
                                    <MenuItem sx={{ p: 0 }} onClick={() => {
                                        setActiveOrganization(o);
                                        handleDropdownClose()
                                    }}>
                                        <Box sx={styles}>
                                            {o.name}&nbsp;
                                            {o.active ? <Icon icon="mdi:tick" color={theme.palette.success.main} /> : ""}
                                        </Box>
                                    </MenuItem>
                                </Tooltip>
                            ))
                        }

                    </Menu>
                </>
            }
        </>
    )
}

export default UserDropdown
